export const USA_MAP_CENTER = { lat: 39.8283, lng: -98.5795 };
